import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api from "@/lib/api";
import { errText } from "./shared";

/** Super admins grant/revoke `gift_card_fulfillment` for admin accounts. */
export function OperatorsPanel({ isSuperAdmin }) {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    try { setItems((await api.get("/admin/rewards/fulfilment/operators")).data.items || []); } catch { setItems([]); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (u) => {
    const reason = window.prompt(`${u.can_fulfil ? "Revoke" : "Grant"} gift card fulfilment for ${u.email}? Reason:`);
    if (!reason || reason.trim().length < 3) return;
    try {
      await api.post(`/admin/rewards/fulfilment/operators/${u.id}`, { grant: !u.can_fulfil, reason });
      toast.success("Permission updated.");
      load();
    } catch (e) { toast.error(errText(e, "Could not update permission")); }
  };

  return (
    <div className="pf-card p-5" data-testid="gc-operators-panel">
      <div className="flex items-center gap-2 mb-3">
        <KeyRound className="w-4 h-4 text-slate-500" />
        <h2 className="font-display text-lg text-slate-900">Fulfilment operators</h2>
      </div>
      <p className="text-xs text-slate-500 mb-3">Only operators can enter gift card details, fulfil orders or return cashback. Super admins always can; other admins have view-only access until granted.</p>
      <ul className="divide-y divide-slate-100 text-sm">
        {items.map((u) => (
          <li key={u.id} className="flex items-center justify-between py-2 gap-3" data-testid={`gc-operator-${u.id}`}>
            <div className="min-w-0">
              <div className="truncate text-slate-900">{u.email}</div>
              <div className="text-[11px] text-slate-500">{u.role === "super_admin" ? "Super admin" : "Admin"}</div>
            </div>
            {u.role === "super_admin" ? (
              <span className="text-[11px] text-emerald-700 font-semibold">Operator</span>
            ) : isSuperAdmin ? (
              <button onClick={() => toggle(u)} data-testid={`gc-operator-toggle-${u.id}`}
                      className={`text-xs px-3 py-1 rounded-full border font-semibold ${u.can_fulfil ? "border-rose-200 text-rose-700" : "border-cyan-200 text-cyan-800"}`}>
                {u.can_fulfil ? "Revoke" : "Grant"}
              </button>
            ) : (
              <span className="text-[11px] text-slate-500">{u.can_fulfil ? "Operator" : "View only"}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
